'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdAttachment = function MdAttachment(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm3.4 20.9c0-5.1 4-9.3 9.1-9.3h17.5c3.7 0 6.6 3.1 6.6 6.8s-2.9 6.6-6.6 6.6h-14.1c-2.3 0-4.3-1.9-4.3-4.1s2-4.3 4.3-4.3h12.5v3.4h-12.7c-0.9 0-0.9 1.6 0 1.6h14.3c1.8 0 3.4-1.4 3.4-3.2s-1.6-3.4-3.4-3.4h-17.5c-3.2 0-5.9 2.7-5.9 5.9s2.7 5.7 5.9 5.7h15.9v3.4h-15.9c-5.1 0-9.1-4.1-9.1-9.1z' })
        )
    );
};

exports.default = MdAttachment;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/attachment.js
// module id = 2835
// module chunks = 0